// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details_container__WcIjY","title":"ingredient-details_title__RWELV","items":"ingredient-details_items__LWp-Q","item":"ingredient-details_item__EhJhY"};